import ResourceRowData from "./ResourceRowData";
import DataBuilder from "./DataBuilder/";
import RestApiSelector from "./RestApiSelector/RestApiSelector";
import MultiResourceSelector from "./MultiResourceSelector";
import DataFilter from "./Filters/DataFilter";
import Grouping from "./Grouping";
import Chart from "./Chart/Chart";
import HyperLink from "./HyperLink";
import ResourceList from "../ResourceList";

export default function ResourceView(props) {
  const { section } = props;

  const handleConnectionChange = (resId) => {
    props.getSelectedConnection(resId);
  };

  const handleSetSelectedResource = (data) => {
    props.setSelected(data);
  };

  // ── RESOURCE section ──
  if (section === "resource") {
    return (
      <>
        <ResourceList
          resourceList={props.resourceList}
          addNewResource={props.addNewResource}
          onChangeResourceType={props.onChangeResourceType}
          selectedResource={props.selectedResource}
          setSelected={handleSetSelectedResource}
          removeResourceItem={props.removeResourceItem}
        />

        {props.connectionType === "Rest API" && (
          <RestApiSelector
            getSelectedConnection={handleConnectionChange}
            connections={props.connections.filter((rd) => rd.resoueceType === "Rest API")}
            selectedResource={props.selectedResource}
            dashboardConfig={props.dashboardConfig}
            setSelected={handleSetSelectedResource}
          />
        )}

        {props.connectionType === "Combined Resource" && (
          <MultiResourceSelector
            getSelectedConnection={handleConnectionChange}
            connections={props.connections.filter((rd) => rd.resoueceType === "Rest API")}
            selectedResource={props.selectedResource}
            dashboardConfig={props.dashboardConfig}
          />
        )}
      </>
    );
  }

  // ── RAW DATA section ──
  if (section === "rawdata") {
    return (
      <ResourceRowData
        reportDataObject={props.reportDataObject}
        reportDataStatus={props.reportDataStatus}
        selectedResource={props.selectedResource}
      />
    );
  }

  // ── FILTERS section ──
  if (section === "filters") {
    return (
      <DataFilter
        reportDataObject={props.reportDataObject}
        reportDataStatus={props.reportDataStatus}
        selectedResource={props.selectedResource}
        connectionType={props.connectionType}
      />
    );
  }

  // ── BUILDER section ──
  if (section === "builder") {
    return (
      <DataBuilder
        reportDataObject={props.reportDataObject}
        reportDataStatus={props.reportDataStatus}
        selectedResource={props.selectedResource}
        activeWidgetName={props.activeWidgetName}
        getSelectedConnection={props.getSelectedConnection}
      />
    );
  }

  // ── GROUPING section (table only) / CHART section (chart only) ──
  if (section === "grouping") {
    if (props.activeWidgetName === "table") {
      return (
        <Grouping
          reportDataObject={props.reportDataObject}
          reportDataStatus={props.reportDataStatus}
          selectedResource={props.selectedResource}
          updateSelectedFields={props.updateSelectedFields}
          activeWidgetName={props.activeWidgetName}
          getSelectedConnection={props.getSelectedConnection}
        />
      );
    }
    if (props.activeWidgetName === "chart") {
      return (
        <Chart
          reportDataObject={props.reportDataObject}
          reportDataStatus={props.reportDataStatus}
          selectedResource={props.selectedResource}
          activeChartType={props.activeChartType}
        />
      );
    }
    return <div style={{ color: "#bfbfbf", padding: "8px" }}>Select a widget type first.</div>;
  }

  // ── HYPERLINK section ──
  if (section === "hyperlink") {
    return (
      <HyperLink
        reportDataObject={props.reportDataObject}
        reportDataStatus={props.reportDataStatus}
        selectedResource={props.selectedResource}
        connectionType={props.connectionType}
      />
    );
  }

  return null;
}
